import BasicLayout from "../../layout/curr.vue"
// const pre = ' - 极客轻商城系统';
const meta = {
  auth: true
};

export default {
  path: 'user',
  name: 'user',
  component: BasicLayout,
  children: [{
      path: 'info',
      name: 'info',
      component: () => import("@/pages/admin/user/info.vue"),
      meta: {
        ...meta,
        title: '个人信息 - 极客商城系统'
      }
    },
    {
      path: 'log',
      name: 'log',
      component: () => import("@/pages/admin/user/log.vue"),
      meta: {
        ...meta,
        title: '操作日志 - 极客商城系统'
      }
    },
   
    {
      path: 'update',
      name: 'update',
      component: () => import("@/pages/admin/user/update.vue"),
      meta: {
        ...meta,
        title: '软件更新 - 极客商城系统'
      }
    },
    {
      path: "*",
      redirect: '/home'
    },

  ]
};